export default "__VITE_ASSET__CuLTA_68__"